// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__19R3i","header":"MergedInvoice_header__2HP3u"};